import autobind from 'autobind-decorator'
import React from 'react'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withMutation(gql`
  mutation acceptInvitation($memberId: ID) {
    acceptInvitation(memberId: $memberId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation declineInvitation($memberId: ID) {
    declineInvitation(memberId: $memberId) {
      success
    }
  }
`)
@withGraphQL(
  gql`
    query member($memberId: ID) {
      member(memberId: $memberId) {
        _id
        organization {
          name
          slug
        }
      }
    }
  `
)
@withMessage
export default class Accept extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    member: PropTypes.object,
    acceptInvitation: PropTypes.func
  }

  @autobind
  async accept() {
    try {
      console.log(this.props.member._id)
      await this.props.acceptInvitation({memberId: this.props.member._id})
      window.location.href = `https://${this.props.member.organization.slug}.tufirma.digital`
    } catch (error) {
      console.log('Error', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
  }

  @autobind
  async decline() {
    try {
      await this.props.declineInvitation({memberId: this.props.member._id})
      this.props.router.push('/')
    } catch (error) {
      console.log('Error', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
  }

  render() {
    const orgUrl = `https://${this.props.member.organization.slug}.tufirma.digital`
    return (
      <div className="section">
        <div className="header">Invitación</div>
        <div className="content">
          <p>
            Has sido invitado a la organización {this.props.member.organization.name}. Esto
            significa que gozarás de los beneficios que el plan de la Organización te entrega.
          </p>
          <p>
            Para iniciar sesión en la organización una vez hayas aceptado la invitación, deberás
            hacerlo desde <a href={orgUrl}>{orgUrl}</a>
          </p>
          <Button primary style={{marginTop: 30}} onClick={this.accept}>
            Aceptar Invitación
          </Button>
          <Button style={{marginTop: 30}} onClick={this.decline}>
            Rechazar
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/Accept/index.js